import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { PageProps } from '../components/component-switcher';
import { FontComponentProps } from '../components/font-component';
// import PageGrid from "../components/page-grid";
import SectionTitle from '../components/section-title';
import { createCategories, generateSectionId } from '../helpers/layout-helpers';

export interface FontArchiveState {
  selectedCategory: FontComponentProps | any;
  arrowTop?: number;
}

class FontArchive extends React.Component<PageProps, FontArchiveState> {
  constructor(props: PageProps) {
    super(props);
    const categories = createCategories(
      this.props.itemChildren || [],
      this.props.component
    );
    const state = props.itemChildren
      ? { selectedCategory: categories[0] }
      : { selectedCategory: {} };
    this.state = state;
  }

  public currentRef = React.createRef<any>();
  public prevActiveElement = null;

  componentDidUpdate() {
    let activeElement = this.currentRef.current?.querySelector('.active');
    if (this.prevActiveElement !== activeElement) {
      this.prevActiveElement = activeElement;

      const top =
        activeElement.getBoundingClientRect().top -
        this.currentRef.current?.getBoundingClientRect().top +
        activeElement.getBoundingClientRect().height / 2;
      this.setState({ arrowTop: top });
    }
  }
  scrollToPageBody() {}

  switchCategory(cat: any) {
    this.setState({ selectedCategory: cat });
  }

  render() {
    let className = `page-container standard-section ${this.props.type.toLowerCase()}`;
    let Component = this.props.component;
    if (this.props.sideMenuTitle) {
      className += ' can-scroll-to';
    }

    const categories = createCategories(
      this.props.itemChildren || [],
      Component
    );
    let arrowStyle = { top: this.state.arrowTop || 0 };
    return (
      <section className={className} id={generateSectionId(this.props)}>
        <SectionTitle title={this.props.mainTitle} />
        {this.props.pageDescription && (
          <div
            className='text-content'
            dangerouslySetInnerHTML={{
              __html: this.props.pageDescription,
            }}></div>
        )}
        <div className='fonts-container'>
          <div className='category-selector'>
            <ul ref={this.currentRef} style={categories?.length === 1 ? {display:"none"} : {}}>
              {categories.map((cat) => {
                let catClass = '';
                const isActive = this.state.selectedCategory.key === cat.key;
                if (isActive) {
                  catClass += 'active';
                }
                return (
                  <li
                    key={cat.key}
                    className={catClass}
                    onClick={() => this.switchCategory(cat)}>
                    {cat.heading}
                  </li>
                );
              })}
              <FontAwesomeIcon style={arrowStyle} icon={faArrowRight} />
            </ul>
          </div>
          <div className='selected-category'>
            {this.state.selectedCategory?.itemChildren?.map(
              (item: any) =>
                Component && (
                  <>
                    <Component
                      {...{
                        ...item,
                        description: Array.isArray(this.props.children)
                          ? this.props.children
                              ?.filter((f: any) => f.id === item.id)
                              ?.map((c: any) => c?.description)
                          : null,
                      }}
                    />
                  </>
                )
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default FontArchive;
